<mat-toolbar color="primary">
    <span *ngIf="userIsAuthenticated"><a routerLink="/photos">Photoes</a></span>
    <span *ngIf="!userIsAuthenticated"><a routerLink="">HOME</a></span>

    <span class="spacer"></span>

    <ul>
        <li *ngIf="userIsAuthenticated">
            <a mat-button routerLink="/create" routerLinkActive="mat-accent ">upload Photo</a>
        </li>

        <li *ngIf="!userIsAuthenticated">
            <a mat-button routerLink="/auth/login" routerLinkActive="mat-accent ">Login</a>
        </li>

        <li *ngIf="!userIsAuthenticated">
            <a mat-button routerLink="/auth/signup" routerLinkActive="mat-accent ">Signup</a>
        </li>

        <li *ngIf="userIsAuthenticated">
            <button mat-button (click)="onLogout()">Logout</button>
        </li>



    </ul>

</mat-toolbar>